import script from "./UiBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./UiBadge.vue?vue&type=script&setup=true&lang=js"

import "./UiBadge.vue?vue&type=style&index=0&id=50fd9336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50fd9336"]])

export default __exports__